const state = {
  widgets: {}
}

const getters = {
  getWidgets: (state) => (parent) => {
    return state.widgets[parent] || []
  }
}

const mutations = {
  registerWidget (state, { parent, name }) {
    const w = {}
    w[parent] = []
    state.widgets = Object.assign({}, w, state.widgets)

    state.widgets[parent].push(name)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
